import { z } from "zod";
import { apiClient } from "../client";
import {
  companySchema,
  profileQueryResponseSchema,
  profileFiltersResponseSchema,
} from "./schemas";
import type {
  Company,
  CreateCompanyRequest,
  UpdateCompanyStatusRequest,
  ProfileQueryRequest,
  ProfileQueryResponse,
  ProfileFiltersResponse,
} from "./types";

export async function getCompanies(): Promise<Company[]> {
  const response = await apiClient.get("companies", {}).json<Company[]>();
  return z.array(companySchema).parse(response);
}

export async function getActiveCompanies(): Promise<Company[]> {
  const response = await apiClient
    .get("companies/active", {})
    .json<Company[]>();
  return z.array(companySchema).parse(response);
}

export async function getCompany(id: string | number): Promise<Company> {
  const response = await apiClient.get(`companies/${id}`, {}).json<Company>();
  return companySchema.parse(response);
}

export async function createCompany(
  data: CreateCompanyRequest
): Promise<Company> {
  const response = await apiClient
    .post("companies", { json: data })
    .json<Company>();
  return companySchema.parse(response);
}

export async function getProfiles(
  request: ProfileQueryRequest
): Promise<ProfileQueryResponse> {
  const response = await apiClient
    .post("companies/profiles", { json: request })
    .json<ProfileQueryResponse>();
  return profileQueryResponseSchema.parse(response);
}

export async function getProfileFilters(): Promise<ProfileFiltersResponse> {
  const response = await apiClient
    .get("companies/profiles/filters", {})
    .json<ProfileFiltersResponse>();
  return profileFiltersResponseSchema.parse(response);
}

export async function deleteCompany(id: string | number): Promise<void> {
  await apiClient.delete(`companies/${id}`, {});
}

export async function updateCompany(
  id: string | number,
  data: CreateCompanyRequest
): Promise<Company> {
  const response = await apiClient
    .put(`companies/${id}`, { json: data })
    .json<Company>();
  return companySchema.parse(response);
}

export async function updateCompanyStatus(
  id: string | number,
  data: UpdateCompanyStatusRequest
): Promise<Company> {
  const response = await apiClient
    .put(`companies/${id}/status`, { json: data })
    .json<Company>();
  return companySchema.parse(response);
}
